import { Component, OnInit, Input } from '@angular/core';
import { CustomNavParams } from 'src/shared/providers/custom-nav-params/custom-nav-params';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';

@Component({
    selector: 'request-times-section',
    templateUrl: './request-times-section.component.html',
    styleUrls: ['./request-times-section.component.scss'],
    standalone: false
})
export class RequestTimesSectionComponent implements OnInit {
  @Input() cleaning;

  constructor(
    private customNavParams: CustomNavParams,
    private navCtrl: CustomNavController
  ) { }

  ngOnInit() {
    // No initialization needed
  }

  goToCancelRequest(availabilityRequest, hkName: string) {
    this.customNavParams.setParams('cancel-request', {...availabilityRequest, hkName});
    this.navCtrl.navigateForward(['cancel-request', availabilityRequest.id]);
  }

  goToRequestCounteredTimes(availabilityRequest, homekeeper) {
    this.customNavParams.setParams('request-countered', {
      planFrequency: availabilityRequest.frequency,
      planType: availabilityRequest.service_type,
      requestTimes: availabilityRequest.request_times,
      hkName: homekeeper.homekeeper_name,
      hkId: homekeeper.homekeeper_id,
      availabilityRequestId: availabilityRequest.id
    });

    this.navCtrl.navigateForward(['request-countered']);
  }

  goToEditRequestTimes(availabilityRequest, homekeeper) {
    this.navCtrl.navigateForward(['request-times', 'edit'], {
      planFrequency: availabilityRequest.frequency,
      planType: availabilityRequest.service_type,
      requestTimes: availabilityRequest.request_times,
      hkName: homekeeper.homekeeper_name,
      hkId: homekeeper.homekeeper_id,
      availabilityRequestId: availabilityRequest.id
    });
  }
}
